import React, { FC } from "react";
import classNames from "classnames";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { Button, RichText } from "@app/components/base-page/models";
import { LinkButtonAdapter } from "../../../link-button-adapter/LinkButtonAdapter";

type Props = {
  title: RichText;
  text: RichText;
  button?: Button[];
  className?: string;
};

export const ContentBlock: FC<Props> = ({ title, text, button, className }) => (
  <div className={classNames(className)}>
    <div
      className={classNames(
        "mb-5 text-medium text-primary-content",
        "lg:text-large",
        "xl:text-xx-large",
      )}
    >
      <BlockHeader richText={title} />
    </div>
    {text ? (
      <div
        className={classNames(
          "list-image-checkmark text-regular text-base-400",
          "[&>p]:mb-2.5",
          "[&_ul>li]:pl-3 [&_ul]:mt-5 [&_ul]:pl-6",
          "[&_ul]:list-disc [&_ul]:text-start",
          "[&_ul]:space-y-2.5",
          "[&_ul]:md:columns-2 [&_ul]:md:gap-x-10",
          "[&_ul]:md:gap-x-15",
          "[&>p]:lg:mb-5 [&_ul]:lg:mt-15",
          {
            "mb-5 lg:mb-8": button?.length,
          },
        )}
      >
        <BlockBody richText={text} />
      </div>
    ) : null}
    {button?.length ? <LinkButtonAdapter data={button[0]} /> : null}
  </div>
);
